


























































































































import Vue from 'vue'
import { Address } from '@/model/planning/Address'
import {
  EDIT_ADDITIONAL_SERVICE,
  INSERT_ADDITIONAL_SERVICE, SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { Employee } from '@/model/companyStructure/Employee'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { AdditionalServices } from '@/model/planning/AdditionalServices'
import { AdditionalServicesProduct } from '@/model/planning/AdditionalServicesProduct'
import { AdditionalServicePayload } from '@/types/payload'
import { DatePeriod } from '@/model/DatePeriod'
import moment from 'moment'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import AdditionalServicesWarningDialog from '@/components/planning/AdditionalServicesWarningDialog.vue'

interface ComponentData {
  saveInProgress: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  valid: boolean
  validationRules: Array<Function>
  numberValidationRules: Array<Function>
  selectedProductId: number | null
  selectedProduct: AdditionalServicesProduct | null
  selectedUnitId: number | null
  selectedUnitName: string
  price: string | null
  selectedCurrencyId: number | null
  selectedCurrencyName: string
  amount: string | null
  productName: string

  addressList: Address[]
  address: Address | null
  addressLabel: string
  search: string | null
  selected: boolean
  isLoading: boolean
  employeeList: Employee[]
  employee: number | null
  description: string

  showWarningDialog: boolean
  month1: string
  month2: string
}

export default Vue.extend({
  name: 'AdditionalServicesFormDialog',

  components: {
    AdditionalServicesWarningDialog
  },

  props: {
    show: Boolean,
    title: String,
    dialogData: {
      type: Object as () => AdditionalServices
    },
    productProvisionDiscountList: Array as () => AdditionalServicesProduct[],
    additionalServicesAction: Number,
    expensesAction: Number,
    isEdit: Boolean,
    period: Object as () => DatePeriod
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()
    const numberRule = (value: any): boolean | string => (value >= 0) || this.$t('masterData.addresses.required').toString()

    return {
      saveInProgress: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      valid: true,
      validationRules: [required],
      numberValidationRules: [numberRule],
      selectedProductId: null,
      selectedProduct: null,
      selectedUnitId: null,
      selectedUnitName: '',
      price: null,
      selectedCurrencyId: null,
      selectedCurrencyName: '',
      amount: null,
      productName: '',

      addressList: [],
      address: null,
      addressLabel: '',
      search: null,
      selected: false,
      isLoading: false,
      employeeList: [],
      employee: null,
      description: '',

      showWarningDialog: false,
      month1: '',
      month2: ''
    }
  },

  watch: {
    search (newVal: string): void {
      // Items have already been requested
      if (this.isLoading) return

      // Lazily load input items
      if(newVal && newVal.length > 2 && !this.selected) {
        this.searchAddress()
      }

      this.selected = false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    getTotal (): string {
      if(this.amount && this.price) {
        return (Math.round(parseFloat(this.amount) * parseFloat(this.price) * 100) /100).toFixed(2)
      } else {
        return ''
      }
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onAddressSelect (): void {
      this.selected = true
    },

    async searchAddress(): Promise<void> {
      this.isLoading = true
      try {
        const data: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_LIST, this.search)
        this.addressList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },

    onSelectedProductChange (): void {
      if(this.selectedProduct) {
        this.selectedProductId = this.selectedProduct.id
        this.selectedUnitName = this.selectedProduct.unit
        this.price = this.selectedProduct.price.toFixed(2).toString()
        this.selectedCurrencyName = this.selectedProduct.currency
      }
    },

    onAmountChange (): void {
      if(this.amount && parseFloat(this.amount) !== 0) {
        this.amount =  parseFloat(this.amount).toFixed(3).toString()
      } else {
        this.amount = null
      }
    },

    onPriceChange (): void {
      if(this.price && parseFloat(this.price) >= 0) {
        this.price =  parseFloat(this.price).toFixed(2).toString()
      } else {
        this.price = null
      }
    },

    onDialogClose (): void {
      this.$emit('close')
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    onWarningDialogSave (item: number): void {
      this.save(item)
      this.showWarningDialog = false
    },

    onSaveButtonClick () {
      this.save()
    },

    save (item?: number): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if (this.isEdit) {
          const payload: AdditionalServicePayload = {
            id: this.isEdit ? this.dialogData.id : null,
            LGID: this.selectedProduct!.LGID,
            addressId: this.isEdit ? this.dialogData.addressId : this.address ? this.address.id : 0,
            year: parseInt(moment(this.period!.startDate).format('YYYY')),
            month: parseInt(moment(this.period!.startDate).format('M')),
            employeeId: this.employee ? this.employee : 0,
            productId: this.selectedProductId!,
            amount: parseFloat(this.amount!),
            price: parseFloat(this.price!),
            description: this.description,
            currency: this.selectedCurrencyName,
            type: this.additionalServicesAction === 1 ? 'LEISTUNGEN' : ''
          }

          this.editAdditionService(payload)

        } else if (moment(this.period!.startDate).format('M') === moment(this.period!.endDate).format('M')) {
          const payload: AdditionalServicePayload = {
            id: this.isEdit ? this.dialogData.id : null,
            LGID: this.selectedProduct!.LGID,
            addressId: this.isEdit ? this.dialogData.addressId : this.address ? this.address.id : 0,
            year: parseInt(moment(this.period!.startDate).format('YYYY')),
            month: parseInt(moment(this.period!.startDate).format('M')),
            employeeId: this.employee ? this.employee : 0,
            productId: this.selectedProductId!,
            amount: parseFloat(this.amount!),
            price: parseFloat(this.price!),
            description: this.description,
            currency: this.selectedCurrencyName,
            type: this.additionalServicesAction === 1 ? 'LEISTUNGEN' : ''
          }

          this.createAdditionService(payload)

        } else if (item) {
          const year: number = item === 1 ? parseInt(moment(this.period!.startDate).format('YYYY')) : parseInt(moment(this.period!.endDate).format('YYYY'))
          const month: number = item === 1 ? parseInt(moment(this.period!.startDate).format('M')) : parseInt(moment(this.period!.endDate).format('M'))

          const payload: AdditionalServicePayload = {
            id: this.isEdit ? this.dialogData.id : null,
            LGID: this.selectedProduct!.LGID,
            addressId: this.isEdit ? this.dialogData.addressId : this.address ? this.address.id : 0,
            year: year,
            month: month,
            employeeId: this.employee ? this.employee : 0,
            productId: this.selectedProductId!,
            amount: parseFloat(this.amount!),
            price: parseFloat(this.price!),
            description: this.description,
            currency: this.selectedCurrencyName,
            type: this.additionalServicesAction === 1 ? 'LEISTUNGEN' : ''
          }

          this.createAdditionService(payload)

        } else {
          this.month1 = moment(this.period!.startDate).locale(this.selectedLanguage).format('MMMM')
          this.month2 = moment(this.period!.endDate).locale(this.selectedLanguage).format('MMMM')
          this.showWarningDialog = true
        }
      }
    },

    async createAdditionService (payload: AdditionalServicePayload): Promise<void> {
      try {
        this.saveInProgress = true
        const response: boolean = await this.$store.dispatch(INSERT_ADDITIONAL_SERVICE, payload)
        if(response) {
          this.$emit('saved')
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveInProgress = false
      }
    },

    async editAdditionService (payload: AdditionalServicePayload): Promise<void> {
      try {
        this.saveInProgress = true
        const response: boolean = await this.$store.dispatch(EDIT_ADDITIONAL_SERVICE, payload)
        if(response) {
          this.$emit('saved')
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveInProgress = false
      }
    },
  },

  mounted () {
    this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList.filter((item: Employee) => item.planbar)
    if(this.dialogData) {
      const foundProduct: AdditionalServicesProduct | undefined = this.productProvisionDiscountList.find((item: AdditionalServicesProduct) => item.id === this.dialogData.productId)
      this.selectedProduct = foundProduct ? foundProduct : null
      this.selectedProductId = this.dialogData.productId
      this.selectedUnitName = foundProduct ? foundProduct.unit : ''
      this.price = this.dialogData.price
      this.selectedCurrencyName = this.dialogData.currency ? this.dialogData.currency : ''
      this.amount = this.dialogData.quantity
      this.productName = foundProduct ? foundProduct.name : ''
      this.addressLabel = `${this.dialogData.addressNumber} ${this.dialogData.addressName}`
      this.description = this.dialogData.description
      this.employee = this.dialogData.employeeId ? this.dialogData.employeeId : null
    }
  }
})
